import { makeStyles, Link as MuiLink } from '@material-ui/core'
import clsx from 'clsx'

const useStyles = makeStyles(theme => ({
  mainText: {
    color: '#828282',
    fontSize: 12,
    fontWeight: 400,
  }
}))

const ProtectedByRecaptcha = ({ className }) => {

  const classes = useStyles()

  // not used in this version but may be used again, so I will leave it return null
  return null
}

export default ProtectedByRecaptcha